import { createAction } from '@reduxjs/toolkit';
import { ProductModel } from '../../types/Models/ProductTableModel';

export const CHANGE_ORDER_PRODUCT = 'CHANGE_ORDER_PRODUCT';

export const changeOrderProduct = createAction(
    CHANGE_ORDER_PRODUCT,
    ({ id, count, orderProducts } :{id: number, count: number, orderProducts: ProductModel}) => ({ payload: { id, count, orderProducts } }),
);
